import PageShell from "@/components/site/PageShell";

// Impressum according to § 5 TMG.
// NOTE: placeholder values marked with «…» must be replaced with real company
// data by the operator before going live.
export default function Impressum() {
  return (
    <PageShell
      testId="impressum-page"
      eyebrow="Rechtliches"
      title="Impressum"
      subtitle="Angaben gemäß § 5 TMG."
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-4">
          <div className="lg:sticky lg:top-28 space-y-2 rounded-2xl border border-white/5 bg-white/[0.02] p-5">
            <div className="font-mono-bp text-[10px] tracking-[0.3em] uppercase text-white/40 mb-2">
              Inhalt
            </div>
            {TOC.map((t) => (
              <a
                key={t.href}
                href={t.href}
                className="block text-sm text-white/70 hover:text-[#00FAF8] py-1 bp-link"
              >
                {t.label}
              </a>
            ))}
          </div>
        </aside>

        <article className="lg:col-span-8 space-y-12">
          <Section id="anbieter" title="Anbieter">
            <p>
              <strong className="text-white">BeParent | Eltern sein. Eltern bleiben.</strong>
              <br /> Kanalstraße 14
              <br /> 44787 Bochum
                     Deutschland
            </p>
          </Section>

          <Section id="vertretung" title="Vertretungsberechtigte Person">
            <p>Sebastian Graw</p>
          </Section>

          <Section id="kontakt" title="Kontakt">
            <p>
              E-Mail:{" "}
              <a
                href="mailto:hallo@beparent.de"
                className="text-[#00FAF8] bp-link"
              >
                beparent.app@web.de
              </a>
            </p>
          </Section>

          <Section id="verantwortlich" title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
            <p>
              Sebastian Graw
              <br />
              Kanalstraße 14
              <br />
              44787 Bochum
            </p>
          </Section>

          <Section id="streitschlichtung" title="Streitschlichtung">
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00FAF8] bp-link"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              . Unsere E-Mail-Adresse findest du oben im Impressum. Wir sind
              nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor
              einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </Section>

          <Section id="haftung-inhalte" title="Haftung für Inhalte">
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mt-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
              wir diese Inhalte umgehend entfernen.
            </p>
          </Section>

          <Section id="haftung-links" title="Haftung für Links">
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>
          </Section>

          <Section id="urheber" title="Urheberrecht">
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht.
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </Section>

          <p className="text-xs font-mono-bp text-white/40 pt-4 border-t border-white/5">
            Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}
          </p>
        </article>
      </div>
    </PageShell>
  );
}

const TOC = [
  { label: "Anbieter", href: "#anbieter" },
  { label: "Vertretung", href: "#vertretung" },
  { label: "Kontakt", href: "#kontakt" },
  { label: "Verantwortlich", href: "#verantwortlich" },
  { label: "Streitschlichtung", href: "#streitschlichtung" },
  { label: "Haftung für Inhalte", href: "#haftung-inhalte" },
  { label: "Haftung für Links", href: "#haftung-links" },
  { label: "Urheberrecht", href: "#urheber" },
];

function Section({ id, title, children }) {
  return (
    <section id={id} className="scroll-mt-28">
      <h2 className="font-display text-white text-2xl md:text-3xl tracking-tight mb-4">
        {title}
      </h2>
      <div className="text-white/70 leading-relaxed text-[15px] md:text-base space-y-3">
        {children}
      </div>
    </section>
  );
}
